<template>
    <div :class="`ProgressiveImage ProgressiveImage-loading-${fullLoaded}`">
        <!-- Thumbnail -->
        <img
            :src="thumbSrc"
            :alt="alt"
            decoding="async"
            v-show="!fullLoaded"
        />

        <!-- Full res -->
        <img
            v-if="fullSrc"
            :src="fullSrc"
            :alt="alt"
            @load="onFullLoad"
            @error="onFullError"
            loading="lazy"
            decoding="async"
            v-show="fullLoaded"
        />
    </div>
</template>

<script>
export default {
    name: "ProgressiveImage",
    props: {
        thumbSrc: { type: String, required: true },
        fullSrc: { type: String, required: true },
        alt: { type: String, default: "" },
    },
    data() {
        return {
            fullLoaded: false,
        };
    },
    methods: {
        onFullLoad() {
            this.fullLoaded = true;
        },
        onFullError() {
            // Si falla la full, nos quedamos con el thumbnail
            this.fullLoaded = false;
        },
    },
};
</script>

<style scoped>
div{
    width: fit-content;
    height: fit-content;
    position: relative;
}

.ProgressiveImage-loading-false::after{
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #aaaaaa 0px, #ffffff 50%, #aaaaaa 100%);
    background-size: 200% 100%;
    animation: shimmer 1.5s linear infinite; 
    mix-blend-mode: soft-light;
}

@keyframes shimmer {
    0% {
        background-position-x: 100%;
    }
    100% {
        background-position-x: -100%;
    }
}
</style>